var _rect, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYanganqi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 15,
    height: 4,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43365 13.5L1.5765 7.5H14.4235L13.5664 13.5H2.43365Z",
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 3,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 3,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 3,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 1,
    height: 3,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYanganqi);
export default __webpack_public_path__ + "static/media/yanganqi.493656b823d9ae1f5a88b77e5ab09961.svg";
export { ForwardRef as ReactComponent };